import { CaseHistory } from "./Interface/CaseHistory";
import PatientOfflineProcessor from "@/classes/Patients/Offline/processor/PatientOfflineProcessor";
import CaseOfflineProcessor from "./processor/CaseOfflineProcessor";
import SqliteProcessor from "@/processors/SqliteProcessor";
const sqlite = new SqliteProcessor;

class OfflineService implements CaseHistory {
    async index(patient: number, payload: object): Promise<any> {
        await sqlite.connect();
        const item = await PatientOfflineProcessor.viewPatientProfile(patient,payload);
        const cases = await CaseOfflineProcessor.viewCaseCardHistory(patient, payload);
        return {
            data: {
                item: item,
                cases: cases,
            }
        };
    }

    async latestInterventions(patient: number, case_id: number|null = null, payload: object, networkAvailable = true): Promise<any> {
        return null;
    }

    // sync to offline once page has been visited;
    async syncToOffline(payload: any): Promise<any> {
        await sqlite.connect();
        const patientIsNotSync = await PatientOfflineProcessor.checkUnsyncPatient(payload.item.id);
        if (!patientIsNotSync) {
            await PatientOfflineProcessor.syncToOffline(payload);
        }

        await CaseOfflineProcessor.syncToOffline(payload);
    }

    async create(patient: number, payload: any): Promise<any> {
        const defaultResponse= await PatientOfflineProcessor.createPatientCase();
        const patientResponse = await PatientOfflineProcessor.getLatestStoredPatient(patient);
        return {
            data: {
                ...defaultResponse,
                ...{
                    item: patientResponse
                }
            }
        }
    }

    async store(patient: number, payload: object): Promise<any> {
        return {
            data: {
                data: await CaseOfflineProcessor.storePatientCase(patient, payload),
                message: 'Patient successfully created!'
            }
        }
    }

    async edit(patient: number, case_id: number, payload: object): Promise<any> {
        const defaultResponse = await PatientOfflineProcessor.createPatientCase();
        const patientResponse = await PatientOfflineProcessor.getLatestStoredPatient(patient);
        const caseResponse = await CaseOfflineProcessor.editCase(case_id);
        const patientDetail = await PatientOfflineProcessor.transformEditPatient(patientResponse);
        return {
            data: {
                ...defaultResponse,
                ...{
                    patient: patientDetail,
                    item: caseResponse,
                }
            }
        }
    }

    async update(patient: number, case_id: number, payload: object): Promise<any> {
        const data = await CaseOfflineProcessor.updateCase(patient, case_id, payload);
        return {
            data: {
                data: data,
                message: 'Patient successfully updated!'
            }
        }
    }
}

export default new OfflineService();